import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import image from "../../../assets/img/marifer.png";
import { DataCutConvert } from "../functions";

const styles = StyleSheet.create({
  image2: {
    position: "absolute",
    objectPosition: "0",
    zIndex: -999,
    width: "320px",
    height: "320px",
    opacity: 0.2,
  },
  image: {
    position: "absolute",
    objectFit: "cover",
    zIndex: -999,
    width: "100px",
    height: "100px",
    paddingLeft: 0,
    opacity: 0.6,
  },
  photo: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    color: "#ff0080",
    textTransform: "uppercase",
    marginTop: 25,
    paddingLeft: 200,
    fontSize: "18pt",
    fontWeight: "extrabold",
  },
  page: {
    fontSize: "14pt",
    padding: 10,
  },
  mainSection: {
    flexDirection: "row",
    textAlign: "center",
  },
  section1: {
    padding: 8,
    textAlign: "center",
    width: "7cm",
    height: "100%",
    backgroundColor: "white",
    border: 1,
    borderColor: "#0A83F5",
    lineHeight: 1.5,
    fontSize: "10pt",
  },
  section2: {
    padding: 8,
    lineHeight: 4,
    border: 1,
    borderColor: "#0A83F5",
    width: "14.6cm",
    height: "100%",
    backgroundColor: "white",
  },
  viewer: {
    width: "100%",
    height: window.innerHeight,
  },
});

const OrdenCutPDF = ({ data: defaultData }) => {
  const data = DataCutConvert(defaultData);

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        {[1, 2, 3, 4].map((i) => (
          <Page key={i} size="LETTER" style={styles.page}>
            <View>
              <Image style={styles.image} src={image} />
            </View>

            <View style={styles.mainSection}>
              <View>
                <Text style={styles.header}>{"Orden de corte"}</Text>
              </View>
            </View>

            {/* Encargado de corte */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 20,
                paddingLeft: 170,
              }}
            >
              <Text
                style={{ fontSize: "14pt" }}
              >{`Encargado de Corte:  `}</Text>
              <Text style={{ fontSize: "9pt" }}>{data.cutter}</Text>
            </View>

            {/* Modelo */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 10,
                paddingLeft: 170,
              }}
            >
              <Text style={{ fontSize: "14pt" }}>{`Modelo:  `}</Text>
              <Text style={{ fontSize: "9pt" }}>{data.model}</Text>
            </View>

            {/* Tela */}
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                paddingTop: 10,
                paddingLeft: 170,
              }}
            >
              <Text style={{ fontSize: "14pt" }}>{`Tela:  `}</Text>
              <Text
                style={{
                  fontSize: "9pt",
                  flexShrink: 1,
                  width: "60%",
                  lineHeight: 1.2,
                }}
              >
                {data.cloth}
              </Text>
            </View>

            {/* Verificación de vueltas */}
            {/* <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 10,
                paddingLeft: 170,
              }}
            >
              <Text style={{ fontSize: "14pt" }}>{`Verificación de vueltas:  `}</Text>
              <Text style={{ fontSize: "9pt" }}>{data.verifier}</Text>
            </View> */}

            {/* Tiempo promedio de corte */}
            {/* <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 10,
                paddingLeft: 170,
              }}
            >
              <Text style={{ fontSize: "14pt" }}>{`Tiempo promedio de corte:  `}</Text>
              <Text style={{ fontSize: "10pt" }}>{data.cutTime}</Text>
            </View> */}

            {/* Fecha de entrega */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingTop: 10,
                paddingLeft: 170,
              }}
            >
              <Text style={{ fontSize: "14pt" }}>{`Fecha de entrega:  `}</Text>
              <Text style={{ fontSize: "10pt" }}>{data.deliveryDate}</Text>
            </View>

            {/* Imagen */}
            <View>
              <Image
                style={{
                  width: 250,
                  height: 250,
                  paddingTop: 5,
                  marginLeft: 170,
                }}
                src={data.image}
              />
            </View>

            {/* Tabla de tallas */}
            <View
              style={{
                marginTop: 10,
                flexDirection: "row",
                textAlign: "center",
                fontSize: "10pt",
                color: "#000111",
                height: 20,
                backgroundColor: "#f9c6cf",
              }}
            >
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Talla"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Piezas"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Tolerancia"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Total"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Corte"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"No. De Articulo"}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{"Maquilero"}</Text>
              </View>
            </View>

            {data.sizes.map((s, idx) => (
              <View
                key={idx}
                style={{
                  flexDirection: "row",
                  textAlign: "center",
                  fontSize: "8pt",
                  color: "#000111",
                  height: 20,
                }}
              >
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.name}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.pieces}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.percentage}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.total}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.cut}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.cut}</Text>
                </View>
                <View style={{ width: "20%", border: 1 }}>
                  <Text>{s.cut}</Text>
                </View>
              </View>
            ))}

            <View
              style={{
                flexDirection: "row",
                textAlign: "center",
                fontSize: "12pt",
                color: "#000111",
                height: 20,
              }}
            >
              <View style={{ width: "20%" }}>
                <Text>{""}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{data.totals.totalPieces}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{data.totals.totalPercentage}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{data.totals.grandTotal}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{""}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{""}</Text>
              </View>
              <View style={{ width: "20%", border: 1 }}>
                <Text>{""}</Text>
              </View>
            </View>

            {/* Firma */}
            <View
              style={{
                marginTop: 25,
                flexDirection: "column",
                textAlign: "center",
                fontSize: "12pt",
              }}
            >
              <View style={{ width: "100%" }}>
                <Text>{"________________________________"}</Text>
              </View>
              <View style={{ width: "100%" }}>
                <Text>{"Firma de enterado"}</Text>
              </View>
            </View>

            {/* Gerencia */}
            <View
              style={{
                marginTop: 20,
                flexDirection: "column",
                textAlign: "center",
                fontSize: "12pt",
              }}
            >
              <View style={{ width: "100%" }}>
                <Text>{"ATTE:"}</Text>
              </View>
              <View style={{ width: "100%" }}>
                <Text>{"Gerencia de produccion"}</Text>
              </View>
            </View>
          </Page>
        ))}
      </Document>
    </PDFViewer>
  );
};

export default OrdenCutPDF;
